var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPrevArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 8,
    viewBox: "0 0 19 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.11429 4.00045L0.789107 3.67527L0.464844 4.00045L0.789107 4.32563L1.11429 4.00045ZM1.43947 4.32563L5.11383 0.651269L4.46347 0.000905561L0.789107 3.67527L1.43947 4.32563ZM0.789107 4.32563L4.46347 8L5.11383 7.34964L1.43947 3.67527L0.789107 4.32563ZM1.11429 4.45975L18.0339 4.45975L18.0339 3.54116L1.11429 3.54116L1.11429 4.45975Z",
    fill: "#FAFAFA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrevArrow);
export default __webpack_public_path__ + "static/media/prev-arrow.3e091fce9f6af432f3a4eccba6e889a0.svg";
export { ForwardRef as ReactComponent };